import { render, staticRenderFns } from "./SensitivityLabel.vue?vue&type=template&id=ffe9f7a8&"
import script from "./SensitivityLabel.vue?vue&type=script&lang=ts&"
export * from "./SensitivityLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports